import { Component } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import { SettingsChangeBackgroundImage, SettingsChangeBrickWallMargin, SettingsChangeGlobalBrickScaling } from '../../../../store/settings/settings.actions';
import { SettingsState } from '../../../../store/settings/settings.state';

@Component({
   selector: 'samweb-brickwall-settings',
   templateUrl: './brickwall-settings.component.html',
   styleUrls: ['./brickwall-settings.component.scss'],
})
export class BrickwallSettingsComponent {
   @Select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.WEB_AGENT_CHANGE_BRICKS_AND_WALL_SETTINGS))
   public isFeatureEnabled$: Observable<boolean>;

   @Select(SettingsState.getBrickWallMargin)
   public getBrickWallMargin$: Observable<number>;

   @Select(SettingsState.getBackgroundImageUrl)
   public backgroundImage$: Observable<string>;

   @Select(SettingsState.getGlobalBrickScaling)
   public brickScaling$: Observable<number>;

   constructor(private store: Store) {}

   changeBrickWallMargin(margin: number) {
      this.store.dispatch(new SettingsChangeBrickWallMargin(margin));
   }

   backgroundImageChanged(backgroundImageUrl: string) {
      this.store.dispatch(new SettingsChangeBackgroundImage(backgroundImageUrl));
   }

   brickScalingChanged(value: number) {
      this.store.dispatch(new SettingsChangeGlobalBrickScaling(value));
   }
}
